import _classCallCheck from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! react-a11y-dialog 7.3.0 — © Kitty Giraudel */
import * as e from "react";
import * as t from "react-dom";
var i = ":not([inert]):not([inert] *)",
  s = ':not([tabindex^="-"])',
  o = ":not(:disabled)";
var n = ["a[href]".concat(i).concat(s), "area[href]".concat(i).concat(s), "input:not([type=\"hidden\"]):not([type=\"radio\"])".concat(i).concat(s).concat(o), "input[type=\"radio\"]".concat(i).concat(s).concat(o), "select".concat(i).concat(s).concat(o), "textarea".concat(i).concat(s).concat(o), "button".concat(i).concat(s).concat(o), "details".concat(i, " > summary:first-of-type").concat(s), "iframe".concat(i).concat(s), "audio[controls]".concat(i).concat(s), "video[controls]".concat(i).concat(s), "[contenteditable]".concat(i).concat(s), "[tabindex]".concat(i).concat(s)];
function a(e) {
  (e.querySelector("[autofocus]") || e).focus();
}
function l(e, t) {
  if (t && c(e)) return e;
  if (!((i = e).shadowRoot && "-1" === i.getAttribute("tabindex") || i.matches(":disabled,[hidden],[inert]"))) if (e.shadowRoot) {
    var _i = r(e.shadowRoot, t);
    for (; _i;) {
      var _e = l(_i, t);
      if (_e) return _e;
      _i = d(_i, t);
    }
  } else if ("slot" === e.localName) {
    var _i2 = e.assignedElements({
      flatten: !0
    });
    t || _i2.reverse();
    var _iterator = _createForOfIteratorHelper(_i2),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e2 = _step.value;
        var _i3 = l(_e2, t);
        if (_i3) return _i3;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    var _i4 = r(e, t);
    for (; _i4;) {
      var _e3 = l(_i4, t);
      if (_e3) return _e3;
      _i4 = d(_i4, t);
    }
  }
  var i;
  return !t && c(e) ? e : null;
}
function r(e, t) {
  return t ? e.firstElementChild : e.lastElementChild;
}
function d(e, t) {
  return t ? e.nextElementSibling : e.previousElementSibling;
}
var c = function c(e) {
  var _e$shadowRoot;
  return !((_e$shadowRoot = e.shadowRoot) !== null && _e$shadowRoot !== void 0 && _e$shadowRoot.delegatesFocus) && e.matches(n.join(",")) && !function (e) {
    return !(!e.matches("details:not([open]) *") || e.matches("details>summary:first-of-type")) || !(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
  }(e);
};
function h() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var t = e.activeElement;
  return t ? t.shadowRoot ? h(t.shadowRoot) || document.activeElement : t : null;
}
function u(e, t) {
  var _ref = function (e) {
      var t = l(e, !0);
      return [t, t ? l(e, !1) || t : null];
    }(e),
    _ref2 = _slicedToArray(_ref, 2),
    i = _ref2[0],
    s = _ref2[1];
  if (!i) return t.preventDefault();
  var o = h();
  t.shiftKey && o === i ? (s.focus(), t.preventDefault()) : t.shiftKey || o !== s || (i.focus(), t.preventDefault());
}
var f = /*#__PURE__*/function () {
  function f(e) {
    _classCallCheck(this, f);
    _defineProperty(this, "$el", void 0);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "previouslyFocused", void 0);
    _defineProperty(this, "shown", void 0);
    this.$el = e, this.id = this.$el.getAttribute("data-a11y-dialog") || this.$el.id, this.previouslyFocused = null, this.shown = !1, this.maintainFocus = this.maintainFocus.bind(this), this.bindKeypress = this.bindKeypress.bind(this), this.handleTriggerClicks = this.handleTriggerClicks.bind(this), this.show = this.show.bind(this), this.hide = this.hide.bind(this), this.$el.setAttribute("aria-hidden", "true"), this.$el.setAttribute("aria-modal", "true"), this.$el.setAttribute("tabindex", "-1"), this.$el.hasAttribute("role") || this.$el.setAttribute("role", "dialog"), document.addEventListener("click", this.handleTriggerClicks, !0);
  }
  return _createClass(f, [{
    key: "destroy",
    value: function destroy() {
      return this.hide(), document.removeEventListener("click", this.handleTriggerClicks, !0), this.$el.replaceWith(this.$el.cloneNode(!0)), this.fire("destroy"), this;
    }
  }, {
    key: "show",
    value: function show(e) {
      var _this$previouslyFocus;
      return this.shown || (this.shown = !0, this.$el.removeAttribute("aria-hidden"), this.previouslyFocused = h(), "BODY" === ((_this$previouslyFocus = this.previouslyFocused) === null || _this$previouslyFocus === void 0 ? void 0 : _this$previouslyFocus.tagName) && e !== null && e !== void 0 && e.target && (this.previouslyFocused = e.target), a(this.$el), document.body.addEventListener("focus", this.maintainFocus, !0), this.$el.addEventListener("keydown", this.bindKeypress, !0), this.fire("show", e)), this;
    }
  }, {
    key: "hide",
    value: function hide(e) {
      var _this$previouslyFocus2, _this$previouslyFocus3;
      return this.shown ? (this.shown = !1, this.$el.setAttribute("aria-hidden", "true"), (_this$previouslyFocus2 = this.previouslyFocused) !== null && _this$previouslyFocus2 !== void 0 && (_this$previouslyFocus3 = _this$previouslyFocus2.focus) !== null && _this$previouslyFocus3 !== void 0 && _this$previouslyFocus3.call(_this$previouslyFocus2), document.body.removeEventListener("focus", this.maintainFocus, !0), this.$el.removeEventListener("keydown", this.bindKeypress, !0), this.fire("hide", e), this) : this;
    }
  }, {
    key: "on",
    value: function on(e, t, i) {
      return this.$el.addEventListener(e, t, i), this;
    }
  }, {
    key: "off",
    value: function off(e, t, i) {
      return this.$el.removeEventListener(e, t, i), this;
    }
  }, {
    key: "fire",
    value: function fire(e, t) {
      this.$el.dispatchEvent(new CustomEvent(e, {
        detail: t,
        cancelable: !0
      }));
    }
  }, {
    key: "handleTriggerClicks",
    value: function handleTriggerClicks(e) {
      var t = e.target;
      t.closest("[data-a11y-dialog-show=\"".concat(this.id, "\"]")) && this.show(e), (t.closest("[data-a11y-dialog-hide=\"".concat(this.id, "\"]")) || t.closest("[data-a11y-dialog-hide]") && t.closest('[aria-modal="true"]') === this.$el) && this.hide(e);
    }
  }, {
    key: "bindKeypress",
    value: function bindKeypress(e) {
      var _document$activeEleme;
      ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.closest('[aria-modal="true"]')) === this.$el && ("Escape" === e.key && "alertdialog" !== this.$el.getAttribute("role") && (e.preventDefault(), this.hide(e)), "Tab" === e.key && u(this.$el, e));
    }
  }, {
    key: "maintainFocus",
    value: function maintainFocus(e) {
      e.target.closest('[aria-modal="true"], [data-a11y-dialog-ignore-focus-trap]') || a(this.$el);
    }
  }]);
}();
function m() {
  var _iterator2 = _createForOfIteratorHelper(document.querySelectorAll("[data-a11y-dialog]")),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _e4 = _step2.value;
      new f(_e4);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
"undefined" != typeof document && ("loading" === document.readyState ? document.addEventListener("DOMContentLoaded", m) : m());
var $ = function $(t) {
    var _t$role = t.role,
      i = _t$role === void 0 ? "dialog" : _t$role,
      s = t.id,
      _t$titleId = t.titleId,
      o = _t$titleId === void 0 ? "".concat(s, "-title") : _t$titleId,
      _ref3 = function () {
        var _e$useState = e.useState(null),
          _e$useState2 = _slicedToArray(_e$useState, 2),
          t = _e$useState2[0],
          i = _e$useState2[1];
        return [t, e.useCallback(function (e) {
          null !== e && i(new f(e));
        }, [])];
      }(),
      _ref4 = _slicedToArray(_ref3, 2),
      n = _ref4[0],
      a = _ref4[1],
      l = e.useCallback(function () {
        return n && n.hide();
      }, [n]),
      r = "alertdialog" === i;
    return e.useEffect(function () {
      return function () {
        n && n.destroy();
      };
    }, [n]), [n, {
      container: {
        id: s,
        ref: a,
        role: i,
        tabIndex: -1,
        "aria-modal": !0,
        "aria-hidden": !0,
        "aria-labelledby": o
      },
      overlay: {
        onClick: r ? void 0 : l
      },
      dialog: {
        role: "document"
      },
      closeButton: {
        type: "button",
        onClick: l
      },
      title: {
        role: "heading",
        "aria-level": 1,
        id: o
      }
    }];
  },
  y = function y(i) {
    var _i$role = i.role,
      s = _i$role === void 0 ? "dialog" : _i$role,
      o = i.id,
      _i$titleId = i.titleId,
      n = _i$titleId === void 0 ? "".concat(o, "-title") : _i$titleId,
      _i$closeButtonLabel = i.closeButtonLabel,
      a = _i$closeButtonLabel === void 0 ? "Close this dialog window" : _i$closeButtonLabel,
      _i$closeButtonContent = i.closeButtonContent,
      l = _i$closeButtonContent === void 0 ? "×" : _i$closeButtonContent,
      _i$closeButtonPositio = i.closeButtonPosition,
      r = _i$closeButtonPositio === void 0 ? "first" : _i$closeButtonPositio,
      _i$classNames = i.classNames,
      d = _i$classNames === void 0 ? {} : _i$classNames,
      _i$dialogRef = i.dialogRef,
      c = _i$dialogRef === void 0 ? function () {} : _i$dialogRef,
      h = i.dialogRoot,
      u = i.title,
      f = i.children,
      m = function () {
        var _e$useState3 = e.useState(!1),
          _e$useState4 = _slicedToArray(_e$useState3, 2),
          t = _e$useState4[0],
          i = _e$useState4[1];
        return e.useEffect(function () {
          return i(!0);
        }, []), t;
      }(),
      _$ = $({
        role: s,
        id: o,
        titleId: n
      }),
      _$2 = _slicedToArray(_$, 2),
      y = _$2[0],
      b = _$2[1];
    if (e.useEffect(function () {
      return y && c(y), function () {
        c(void 0);
      };
    }, [c, y]), !m) return null;
    var g = h ? document.querySelector(h) : document.body,
      v = e.createElement("button", _objectSpread(_objectSpread({}, b.closeButton), {}, {
        className: d.closeButton,
        "aria-label": a,
        key: "button"
      }), l);
    return t.createPortal(e.createElement("div", _objectSpread(_objectSpread({}, b.container), {}, {
      className: d.container
    }), e.createElement("div", _objectSpread(_objectSpread({}, b.overlay), {}, {
      className: d.overlay
    })), e.createElement("div", _objectSpread(_objectSpread({}, b.dialog), {}, {
      className: d.dialog
    }), "first" === r && v, e.createElement("p", _objectSpread(_objectSpread({}, b.title), {}, {
      className: d.title,
      key: "title"
    }), u), f, "last" === r && v)), g);
  };
export { y as A11yDialog, $ as useA11yDialog };